<template>

  <section>

	<div v-if="dialogErrTxt" class="alert alert-danger">
		{{ dialogErrTxt }}
	</div>
	<div v-if="dialogOkTxt" class="alert alert-success">
		{{ dialogOkTxt }}
	</div>

    <div class="row">
    	<div class="col-md-12">

			<div class="d-flex flex-row w-100 mb-2"> 
				<h4 class="flex-grow-1 mb-0">
					Informations de facturation
				</h4>
				<button
					type="button"
					@click="showInvoiceAddrDialog"
					class="btn btn-sm btn-primary"
				>
					Modifier
				</button>
			</div>

			<div class="alert alert-light position-relative mb-1">
				<span v-show="row_co.co_invoice_civility ">
					{{getCivility(row_co.co_invoice_civility)}}&nbsp;
				</span>
				{{row_co.co_invoice_firstname}} {{row_co.co_invoice_name}}<br />

				<div class="mt-2">
					{{row_co.co_invoice_address1}} <br />
					<span v-show="row_co.co_invoice_address2">
						{{row_co.co_invoice_address2}} <br/>
					</span>
					{{row_co.co_invoice_zip}} {{row_co.co_invoice_city}} <br />
					{{getCountry(row_co.co_invoice_country)}}
				</div>

				<div class="mt-2">
					<label>email : </label> {{row_co.co_invoice_email}}<br />
					<label>téléphone : </label> {{row_co.co_invoice_tel}}
				</div>
			</div>

		</div>
		<div>
			<div class="form-check form-switch mb-3">
				<input
					class="form-check-input"
					type="checkbox"
					role="switch"
					id="co_adresses_different"
					:checked="areAdressesIdentical"
					@change="copyInvoiceToShippingAddr"
				>
				<label class="form-check-label" for="co_adresses_different">
					Adresse de livraison identique à celle de facturation
				</label>
			</div>
		</div>
	</div>
    <div class="row">
    	<div class="col-md-12">

			<div class="d-flex flex-row w-100 mb-2"> 
				<h4 class="flex-grow-1 mb-0">
					Informations de livraison
				</h4>
				<button
					type="button"
					@click="showShippingAddrDialog"
					class="btn btn-sm btn-primary"
					:disabled="!row_co.co_adresses_different"
				>
					Modifier
				</button>
			</div>

			<div class="alert alert-light position-relative">
				<span v-show="row_co.co_shipping_civility">
					{{getCivility(row_co.co_shipping_civility)}}&nbsp;
				</span>
				{{row_co.co_shipping_firstname}} {{row_co.co_shipping_name}}<br />

				<div class="mt-2">
					<div v-show="row_co.co_shipping_society_name">
						{{row_co.co_shipping_society_name}}
					</div>
					{{row_co.co_shipping_address1}} <br />
					<span v-show="row_co.co_shipping_address2">
						{{row_co.co_shipping_address2}} <br/>
					</span>
					{{row_co.co_shipping_zip}} {{row_co.co_shipping_city}} <br />
					{{getCountry(row_co.co_shipping_country)}}
				</div>

				<div class="mt-2">
					<label>téléphone : </label> {{row_co.co_shipping_tel}}
				</div>
			</div>
		</div>
	</div>

	<div
		ref="modalUpdateInvoiceAddr"
		:style="dialogInvoiceAddr.display ? 'display:block' : 'display:none'"
		:class="dialogInvoiceAddr.display ? 'modal fade show' : 'modal fade'"
		tabindex="-1"
		role="dialog"
	>
		<div class="modal-dialog modal-dialog-centered" role="document">
			<div class="modal-content">
				<form id="paymentForm">
					<div class="modal-header">
						<h5 class="modal-title">Informations de facturation</h5>
					</div>
					<div class="modal-body">

						<div class="row">

							<div class="col-2 g-2">
								<label for="co_invoice_civility">Civilité</label>
								<select
									v-model="row_co.co_invoice_civility"
									class="form-control"
								>
									<option 
										v-for="(option, indexOption) in $store.state.items_civility" :key="indexOption"
										:value="option.value"
									>{{ option.text }}</option>
								</select>
							</div>

							<div class="col-5 g-2">

								<label for="co_invoice_firstname">Prénom</label>
								<input
									type="text"
									class="form-control"
									v-model="row_co.co_invoice_firstname"
								/>
							</div>
							<div class="col-5 g-2">
								<label for="co_invoice_name">Nom</label>
								<input
									type="text"
									class="form-control"
									v-model="row_co.co_invoice_name"
								/>
							</div>
						</div>

						<div class="row">
							<div class="col-6 g-2">
								<label for="co_login">Email</label>
								<input
									type="text"
									class="form-control"
									v-model="row_co.co_invoice_email"
									@input="fillLoginInput"
								/>
							</div>
							<div class="col-6 g-2">
								<label for="co_invoice_tel">Téléphone</label>
								<input
									type="text"
									class="form-control"
									v-model="row_co.co_invoice_tel"
									@change="checkPhone($event.target.value, 'co_invoice_tel')"
								/>
							</div>
						</div>

						<div class="row">
							<div class="col-12 g-2">
								<label for="co_invoice_tel">Adresse</label>

								<div class="position-relative">
									<input
										type="text"
										class="form-control"
										ref="address_research_invoice"
										v-model="row_co.co_invoice_address1"
										placeholder="Adresse"
										v-on:input="checkAddress('invoice')"
									/>
									<div v-if="addressesList1" class="addresses-list">
										<div
											v-for="address in addresses1"
											:key="address.id"
											@click="applyAddress(address, 'invoice')"
										>
											{{ address.label }}
										</div>
										<div @click="closeAddress('invoice')" class="text-end text-right">
											<icon name="times" /> Fermer
										</div>
									</div>

								</div>
							</div>
						</div>

						<div class="row">
							<div class="col-12 g-2">
								<input
									type="text"
									class="form-control mb-2"
									v-model="row_co.co_invoice_address2"
									placeholder="Complément d'adresse"
								/>
							</div>
						</div>

						<div class="row">
							<div class="col-6 g-2">
								<input
									type="text"
									class="form-control"
									v-model="row_co.co_invoice_zip"
									placeholder="Code postal"
								/>
							</div>
							<div class="col-6 g-2">
								<input
									type="text"
									class="form-control"
									placeholder="Ville"
									v-model="row_co.co_invoice_city"
								/>
							</div>
						</div>

						<div class="row">
							<div class="col-6 g-2">
								<select
									v-model="row_co.co_invoice_country"
									class="form-control mb-2"
								>
									<option
										v-for="(option, indexOption) in $store.state.items_countries" :key="indexOption"
										:value="option.value"
									>
										{{ option.text }}
									</option>
								</select>
							</div>
							<div class="col-6 g-2">

							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button
							type="button"
							class="btn btn-secondary"
							@click="closeInvoiceAddrDialog()"
							:disabled="dialogInvoiceAddr.processing"
						>
							Annuler
						</button>
						<button
							type="button"
							@click="saveInvoiceAddrDialog()"
							class="btn btn-primary"
							:disabled="dialogInvoiceAddr.processing"
						>
							<Icon v-if="dialogInvoiceAddr.processing" name="hourglass-half" fill="white" spin />
							Sauvegarder
						</button>
					</div>
				</form>
			</div>
		</div>
	</div>

	<div
		ref="modalUpdateShippingAddr"
		:style="dialogShippingAddr.display ? 'display:block' : 'display:none'"
		:class="dialogShippingAddr.display ? 'modal fade show' : 'modal fade'"
		tabindex="-1"
		role="dialog"
	>
		<div class="modal-dialog modal-dialog-centered" role="document">
			<div class="modal-content">
				<form id="paymentForm">
					<div class="modal-header">
						<h5 class="modal-title">Informations de livraison</h5>
					</div>
					<div class="modal-body">

						<div class="row">

							<div class="col-2 g-2">
								<label for="co_shipping_civility">Civilité</label>
								<select
									v-model="row_co.co_shipping_civility"
									class="form-control"
								>
									<option 
										v-for="(option, indexOption) in $store.state.items_civility" :key="indexOption"
										:value="option.value"
									>{{ option.text }}</option>
								</select>
							</div>

							<div class="col-5 g-2">

								<label for="co_shipping_firstname">Prénom</label>
								<input
									type="text"
									class="form-control"
									v-model="row_co.co_shipping_firstname"
								/>
							</div>
							<div class="col-5 g-2">
								<label for="co_shipping_name">Nom</label>
								<input
									type="text"
									class="form-control"
									v-model="row_co.co_shipping_name"
								/>
							</div>
						</div>

						<div class="row">
							<div class="col-6 g-2">
								<label for="co_shipping_society_name">Société</label>
								<input
									type="text"
									class="form-control"
									v-model="row_co.co_shipping_society_name"
								/>
							</div>
							<div class="col-6 g-2">
								<label for="co_shipping_tel">Téléphone</label>
								<input
									type="text"
									class="form-control"
									v-model="row_co.co_shipping_tel"
									@change="checkPhone($event.target.value, 'co_shipping_tel')"
								/>
							</div>
						</div>

						<div class="row">
							<div class="col-12 g-2">
								<label>Adresse</label>

								<div class="position-relative">
									<input
										type="text"
										class="form-control"
										ref="address_research_shipping"
										v-model="row_co.co_shipping_address1"
										placeholder="Adresse"
										v-on:input="checkAddress('shipping')"
									/>
									<div v-if="addressesList2" class="addresses-list">
										<div
											v-for="address in addresses2"
											:key="address.id"
											@click="applyAddress(address, 'shipping')"
										>
											{{ address.label }}
										</div>
										<div @click="closeAddress('invoice')" class="text-end text-right">
											<icon name="times" /> Fermer
										</div>
									</div>

								</div>
							</div>
						</div>

						<div class="row">
							<div class="col-12 g-2">
								<input
									type="text"
									class="form-control mb-2"
									v-model="row_co.co_shipping_address2"
									placeholder="Complément d'adresse"
								/>
							</div>
						</div>

						<div class="row">
							<div class="col-6 g-2">
								<input
									type="text"
									class="form-control"
									v-model="row_co.co_shipping_zip"
									placeholder="Code postal"
								/>
							</div>
							<div class="col-6 g-2">
								<input
									type="text"
									class="form-control"
									placeholder="Ville"
									v-model="row_co.co_shipping_city"
								/>
							</div>
						</div>

						<div class="row">
							<div class="col-6 g-2">
								<select
									v-model="row_co.co_shipping_country"
									class="form-control mb-2"
								>
									<option
										v-for="(option, indexOption) in $store.state.items_countries" :key="indexOption"
										:value="option.value"
									>
										{{ option.text }}
									</option>
								</select>
							</div>
							<div class="col-6 g-2">

							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button
							type="button"
							class="btn btn-secondary"
							@click="closeShippingAddrDialog()"
							:disabled="dialogShippingAddr.processing"
						>
							Annuler
						</button>
						<button
							type="button"
							@click="saveShippingAddrDialog()"
							class="btn btn-primary"
							:disabled="dialogShippingAddr.processing"
						>
							<Icon v-if="dialogShippingAddr.processing" name="hourglass-half" fill="white" spin />
							Sauvegarder
						</button>
					</div>
				</form>
			</div>
		</div>
	</div>

</section>



  
</template>

<script>

import { phone } from "phone";

export default {
	name: "account",
	components: {},
	props: {
		row_co: {
			default: function () {
				return {};
			},
			type: Object,
		}
	},
	data() {
		return {

			dialogErrTxt: "",
			dialogOkTxt: "",

			shippingPhoneCheck: false,
			billingPhoneCheck: false,

			addresses1: [],
			addresses2: [],
			tvbrands: [],
			addressesList1: false,
			addressesList2: false,

			dialogInvoiceAddr: {
				display: false,
				processing: false,
			},

			dialogShippingAddr: {
				display: false,
				processing: false,
			}
		}
	},

	mounted() {
		this.getTvBrands();

		if (this.row_co.co_invoice_tel) {
			this.checkPhone(this.row_co.co_invoice_tel, "co_invoice_tel");
		}

		if (this.row_co.co_shipping_tel) {
			this.checkPhone(this.row_co.co_shipping_tel, "co_shipping_tel");
		}

		if(!this.row_co.co_shipping_zip && !this.row_co.co_shipping_city) {
			this.shippingPhoneCheck = true
			this.row_co.co_shipping_civility = this.row_co.co_invoice_civility;	
			this.row_co.co_shipping_firstname = this.row_co.co_invoice_firstname;
			this.row_co.co_shipping_name = this.row_co.co_invoice_name;	
			this.row_co.co_shipping_address1 = this.row_co.co_invoice_address1;
			this.row_co.co_shipping_address2 = this.row_co.co_invoice_address2;
			this.row_co.co_shipping_zip = this.row_co.co_invoice_zip;
			this.row_co.co_shipping_city = this.row_co.co_invoice_city;
			this.row_co.co_shipping_country = this.row_co.co_invoice_country;
			this.row_co.co_shipping_tel= this.row_co.co_invoice_tel;
		}
	},

	computed: {

		areAdressesIdentical() {
			return !this.row_co.co_adresses_different;
		}

	},

	methods: {

		getCivility(val) {
			const res = this.$store.state.items_civility.find(item => item.value === val)
			return res ? res.text : "";
		},

		getCountry(val) {
			const res = this.$store.state.items_countries.find(item => item.value === val)
			return res ? res.text : "";
		},

		showInvoiceAddrDialog() {
			this.dialogInvoiceAddr.display = true;
		},

		saveInvoiceAddrDialog() {
			if(this.saveAccount()) {
				this.dialogInvoiceAddr.display = false;
			}
		},

		closeInvoiceAddrDialog() {
			this.dialogInvoiceAddr.display = false;
		},

		showShippingAddrDialog() {
			this.dialogShippingAddr.display = true;
		},

		saveShippingAddrDialog() {
			if(this.saveAccount()) {
				this.dialogShippingAddr.display = false;
			}
		},

		closeShippingAddrDialog() {
			this.dialogShippingAddr.display = false;
		},

		copyInvoiceToShippingAddr(event) {

			const copy = event.target.checked;

			if(copy) {
				this.shippingPhoneCheck = true
				this.row_co.co_shipping_civility = this.row_co.co_invoice_civility;	
				this.row_co.co_shipping_firstname = this.row_co.co_invoice_firstname;
				this.row_co.co_shipping_name = this.row_co.co_invoice_name;	
				this.row_co.co_shipping_address1 = this.row_co.co_invoice_address1;
				this.row_co.co_shipping_address2 = this.row_co.co_invoice_address2;
				this.row_co.co_shipping_zip = this.row_co.co_invoice_zip;
				this.row_co.co_shipping_city = this.row_co.co_invoice_city;
				this.row_co.co_shipping_country = this.row_co.co_invoice_country;
				this.row_co.co_shipping_tel= this.row_co.co_invoice_tel;
				this.row_co.co_adresses_different = false;
				this.saveAccount();
			} else {
				this.row_co.co_adresses_different = true;
			}
		},

		async saveAccount() {

			this.dialogErrTxt = "";
			this.dialogOkTxt = "";

			if (!this.row_co.co_invoice_tel) {
				this.dialogErrTxt = "Veuillez renseigner un numéro de téléphone";
			} else if (this.row_co.co_invoice_tel && !this.billingPhoneCheck) {	
				this.dialogErrTxt = "Veuillez renseigner un numéro de téléphone valide";
			} else if (this.row_co.co_shipping_tel && !this.shippingPhoneCheck) {
				this.dialogErrTxt ="Veuillez renseigner un numéro de téléphone de livraison valide";
			}

			if (this.dialogErrTxt) {
				return false;
			}

			if(!this.row_co.co_adresses_different) {
				this.row_co.co_shipping_civility = this.row_co.co_invoice_civility;	
				this.row_co.co_shipping_firstname = this.row_co.co_invoice_firstname;
				this.row_co.co_shipping_name = this.row_co.co_invoice_name;	
				this.row_co.co_shipping_address1 = this.row_co.co_invoice_address1;
				this.row_co.co_shipping_address2 = this.row_co.co_invoice_address2;
				this.row_co.co_shipping_zip = this.row_co.co_invoice_zip;
				this.row_co.co_shipping_city = this.row_co.co_invoice_city;
				this.row_co.co_shipping_country = this.row_co.co_invoice_country;
				this.row_co.co_shipping_tel= this.row_co.co_invoice_tel;
			}

			let response = await this.$axios.put(this.$config.server_url + "/web/2.0/account", { row_co: this.row_co });

			if (response.data.err) {
				if (response.data.err.key == "contact_login_exists_already") {
					this.dialogErrTxt = "L'email existe déjà";
				} else if (response.data.err.key == "contact_affiliation_code_invalid") {
					this.dialogErrTxt = "Le code d'affiliation est invalide. Laissez vide si vous êtes un particulier.";
				} else {
					this.dialogErrTxt = response.data.err.message;
				}
				return true;
			}

			this.dialogOkTxt = "Les modifications ont été enregistrées";

			window.setTimeout(() => {
				this.dialogOkTxt = "";
			}, 3000);
		},

		async checkAddress(where) {

			where == "invoice"
				? (this.addressesList1 = true)
				: (this.addressesList2 = true);

			try {
				let response = await this.$axios.get(this.$config.server_url + "/web/2.0/contacts/address?co_webaccesstoken_temp=" + this.$store.state.co_webaccesstoken_temp + "&address=" +
					(where == "invoice"
					? this.$refs.address_research_invoice.value
					: this.$refs.address_research_shipping.value)
				);
				// console.log("response :: ", response);

				if (where == "invoice") {
				this.addresses1 = [];
				response.data.data.forEach((address) => {
					this.addresses1.push(address.properties);
				});
				} else if (where == "shipping") {
				this.addresses2 = [];
				response.data.data.forEach((address) => {
					this.addresses2.push(address.properties);
				});
				}

				// console.log(" addresses : " + this.addresses);
			} catch (error) {
				console.warn(error);
			}
		},

		closeAddress(where) {
			if (where == "invoice") {
				this.addressesList1 = false;
				this.addresses1 = [];
			} else if (where == "shipping") {
				this.addressesList2 = false;
				this.addresses2 = [];
			}
		},

		applyAddress(address, where) {
			if (where == "invoice") {
				this.row_co.co_invoice_zip = address.postcode;
				this.row_co.co_invoice_city = address.city;
				this.row_co.co_invoice_address1 = address.name;
				this.$refs.address_research_invoice.value = "";
				this.addressesList1 = false;
			} else if (where == "shipping") {
				this.row_co.co_shipping_zip = address.postcode;
				this.row_co.co_shipping_city = address.city;
				this.row_co.co_shipping_address1 = address.name;
				this.$refs.address_research_shipping.value = "";
				this.addressesList2 = false;
			}
		},

		async getTvBrands() {
			let response = await this.$axios.get(this.$config.server_url + "/web/2.0/tvbrands");
			this.tvbrands = response.data.data;
		},

		checkCondition(variant) {
			if (this.row_co.co_adresses_different && !variant) {
				return false;
			} else {
				return true;
			}
		},

		fillLoginInput(input) {
			this.row_co.co_login = input.target.value;
		},

		checkPhone(telephone, co_phoneField) {
			let result = phone(telephone, { validateMobilePrefix: false });
			if (co_phoneField === "co_shipping_tel") {
				this.shippingPhoneCheck = result.isValid;
			} else if (co_phoneField === "co_invoice_tel") {
				this.billingPhoneCheck = result.isValid;
			}
		}
	}
};
</script>

<style lang="scss" scoped>

.addresses-list {
	width: 100%;
    background-color: #fff;
    border: 1px solid #c0c0c0;
    border-radius: 5px;
    margin: 0 0 30px 0;
    position:absolute;
    z-index: 50;
}

.addresses-list > div {
    border-bottom: 1px solid #5397a5;
    padding: 5px 15px;
    cursor: pointer;
}

.addresses-list > div:last-child {
    border-bottom: 0;
}

.addresses-list > div:hover {
    background-color: rgba(83, 151, 165, 0.3);
}
</style>
